import { render, staticRenderFns } from "./ViewAllFollowerModal.vue?vue&type=template&id=ccf0851c"
import script from "./ViewAllFollowerModal.vue?vue&type=script&lang=js"
export * from "./ViewAllFollowerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports